import React from 'react';

import RadioInput from 'components/partials/radio-input/radio-input';

import { RADIO_OPTIONS } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/related-goals/related-goals.const';

interface RelatedGoalsFiltersProps {
  filterOption: 'linked' | 'all';
  handleFilterChange: (option: 'linked' | 'all') => void;
  isCreation: boolean;
}

const RelatedGoalsFilters = ({
  filterOption,
  handleFilterChange,
  isCreation,
}: RelatedGoalsFiltersProps): React.JSX.Element => (
  <div className="flex gap-x-5">
    <div className="font-semibold text-gray-600">Show</div>
    <div className="flex">
      {RADIO_OPTIONS.map((option) => (
        <RadioInput<'linked' | 'all'>
          key={option.value}
          labelFor={option.value}
          label={option.label}
          radioValue={option.value}
          setAction={(val) => val && handleFilterChange(val)}
          onChange={(val) => val && handleFilterChange(val)}
          value={filterOption}
          customClass="mr-4"
          disabled={option.value === 'linked' && isCreation}
        />
      ))}
    </div>
  </div>
);

export default RelatedGoalsFilters;
